var indentStyle = {"indentZero":"Z9p7w","indentOne":"juyOe","indentTwo":"otlTz","indentThree":"WYKUP","indentFour":"byw71","indentFive":"ZNtVb","indentSix":"oqKgl"};

export { indentStyle as i };
//# sourceMappingURL=indentation-9f811f7d.js.map
